/*
 * messagesAction.js
 * trt_cms2
 *
 * Created by Hisyam on 28/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

// CREATE MESSAGE
import {AUTH_ERROR, CLEAR_ERRORS, CREATE_MESSAGE, GET_ERRORS} from "../types";

export const createMessage = msg => {
  return {
    type: CREATE_MESSAGE,
    payload: msg
  };
};

// RETURN ERRORS
export const returnErrors = (msg, status) => {
  switch (status) {
    case 401:
      return {
        type: AUTH_ERROR,
        error: true
      };

    default:
      return {
        type: GET_ERRORS,
        payload: { msg, status },
        error: true
      };
  }
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
    payload: {
      msg: {},
      status: null
    }
  };
};
